import {UploadFile} from "antd/es/upload/interface";
import {PropertyFile} from "../../../../../../models/property/property";

export const createFileList = (attachments: PropertyFile[], generateUri: (uri: string) => string): UploadFile[] => {
    return attachments.map(attachment => {

        return {
            uid: attachment.id.toString(),
            name: attachment.fileName,
            fileName: attachment.fileName,
            url: generateUri('/api/v3/property/attachment/' + attachment.hash + '/' + attachment.fileName),
            thumbUrl: generateUri('/api/v3/property/attachment/' + attachment.hash + '/' + attachment.fileName),
            status: 'done',
            size: 0,
            type: ''
        }
    })
}